module.exports = __webpack_public_path__ + "img/ev-drivers-light.c98b0cc8.webp";